import { gql } from '@apollo/client'

export const CURRENT_USER_QUERY = gql`
  query CURRENT_USER_QUERY {
    me {
      id
      sessionIdleMinutes
      email
      username
      name
      phoneNumber
      hasValidNumber
      twoFactorAuth
      language
      isDoctor
      showAttendance
      requireScreenshot
      isOwner
      color
      showOverdue
      shouldResetPassword
      order
      medicalNumber
      job
      specialityCode
      dentalNotation
      doctorPercentage
      diagnosticFee
      diagnosticFeePercent
      labOrderPercent
      automatic
      paymentType
      automaticExpenses
      autoAppointmentStatus
      expensesFrom
      images
      chart
      calendarSync
      userColumns
      maxDiscount
      maxDiscountAnd
      maxDiscountPercent
      starredReports
      testPermissions
      profiles {
        id
        locale
        title
        profession
        bio
      }
      userSystemChat {
        id
        unreadSupport
        unreadPrivate
        unreadInternal
        mentionSupport
        mentionPrivate
        mentionInternal
        supportNotification
        internalNotification
      }
      loggedUsers {
        id
        name
        company {
          id
          companyName
        }
      }
      alertSettings {
        id
        inventory
        masterInventory
        invoice
        reminder
        appointmentQrCode
        pendingPatients
        onlineAppointment
        orders
        operations
        calendar
        treasury
        summaryCron
        appointmentsCron
        newAppointment
        editAppointment
        appointmentStatus
        webNotifications
      }
      group {
        id
        permissions
      }
      branches {
        id
        name
        nphiesCode
        diagnosticFee
        disabled
      }
      profiles {
        id
        locale
        title
        profession
        bio
      }
      company {
        id
        companyName
        companyLoginName
        allowReportedInvoiceEdits
        tierExpiry
        country
        currency
        code
        attendanceLocations
        acceptedRange
        timeZone
        messagesLeft
        showLogoInQr
        confirmInventory
        messagesLimit
        sizeLeft
        sizeLimit
        companyLogo
        tax
        requiredToPay
        allowPrescriptionQR
        allowFormQR
        allowInvoiceQR
        allowLabOrderQR
        allowEncounterQR
        allowChartQR
        allowMedicalQR
        allowExpenseQR
        darkCalendar
        askBeforeSms
        askBeforeOperation
        allowDelete
        maxUsers
        maxBranches
        managerName
        managerPhone
        subscriptionPrice
        whatsappEnabled
        onlinePaymentEnabled
        analyticsEnabled
        googleEnabled
        hasOfficialWhatsapp
        inventoryEnabled
        mobileAppEnabled
        apiEnabled
        leadsEnabled
        uploadEnabled
        patientPointsEnabled
        alertBeforeInventory
        alertBeforeOperations
        alertBeforeMaster
        initialAppointment
        requiredPatientFields
        visiblePatientFields
        requiredLeadFields
        requiredPendingPatientFields
        requiredQrPatientFields
        selectedOperations
        isBeta
        isXolize
        hasCustomApp
        hideQueue
        defaultLanguage
        inventoryStorageTypes
        inventoryTypes
        expenseTypes
        incomeTypes
        paymentTypes
        appointmentTypes
        onlineConvTags
        salaryAdjustmentTypes
        cancellationReasons
        extraSettings
        onlinePaymentActive
        debounceTime
        charts
        googleDriveAuth {
          id
        }
        defaultPayment {
          id
          name
        }
        officialWhatsApp {
          id
          freeTierMonth
          freeTierUsed
        }
      }
    }
  }
`

export const GET_LAST_ATTENDANCE = gql`
  query GET_LAST_ATTENDANCE {
    userLastAttendance {
      id
      createdIp
      updatedIp
      startUseragent
      endUseragent
      startImage
      endImage
      duration
      createdAt
      updatedAt
      details
    }
  }
`

export const TOTAL_ATTENDANCE = gql`
  query TOTAL_ATTENDANCE($userId: ID, $id: ID, $rangeDate: [DateTime!]!, $branchId: ID, $filters: Filter) {
    totalAttendances(userId: $userId, id: $id, rangeDate: $rangeDate, branchId: $branchId, filters: $filters)
  }
`

export const GET_ATTENDANCES = gql`
  query GET_ATTENDANCES(
    $userId: ID
    $id: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $branchId: ID
    $filters: Filter
  ) {
    attendances(
      userId: $userId
      id: $id
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      branchId: $branchId
      filters: $filters
    ) {
      id
      createdIp
      updatedIp
      startUseragent
      endUseragent
      startImage
      endImage
      duration
      createdAt
      updatedAt
      details
      createdLocation
      updatedLocation
      startLatitude
      startLongitude
      startApproved
      endLatitude
      endLongitude
      endApproved
      approved
      branch {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

export const ATTENDANCE_DETAILS = gql`
  query ATTENDANCE_DETAILS($attendance: ID!) {
    attendanceDetails(attendance: $attendance) {
      id
      createdIp
      updatedIp
      startUseragent
      endUseragent
      startImage
      endImage
      duration
      createdAt
      updatedAt
      details
      createdLocation
      updatedLocation
      startLatitude
      startLongitude
      startApproved
      endLatitude
      endLongitude
      endApproved
      approved
      branch {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

export const TOTAL_USER_SESSIONS = gql`
  query TOTAL_USER_SESSIONS($id: ID!, $rangeDate: [DateTime!]!, $filters: Filter) {
    totalUserSessions(user: $id, rangeDate: $rangeDate, filters: $filters)
  }
`

export const USER_SESSIONS = gql`
  query USER_SESSIONS($id: ID!, $orderBy: String!, $skip: Int!, $take: Int!, $rangeDate: [DateTime!]!, $filters: Filter) {
    userSessions(user: $id, orderBy: $orderBy, skip: $skip, take: $take, rangeDate: $rangeDate, filters: $filters) {
      id
      userIP
      useragent
      pushNotification
      createdAt
      current
    }
  }
`

export const USER_SESSION_DETAILS = gql`
  query USER_SESSION_DETAILS($session: ID!) {
    userSessionDetails(session: $session) {
      id
      userIP
      useragent
      pushNotification
      createdAt
      current
    }
  }
`

export const TOTAL_USER_SECURITY_LOGS = gql`
  query TOTAL_USER_SECURITY_LOGS($id: ID!, $rangeDate: [DateTime!]!, $filters: Filter) {
    totalUserSecurityLogs(user: $id, rangeDate: $rangeDate, filters: $filters)
  }
`

export const USER_SECURITY_LOGS = gql`
  query USER_SECURITY_LOGS($id: ID!, $orderBy: String!, $skip: Int!, $take: Int!, $rangeDate: [DateTime!]!, $filters: Filter) {
    userSecurityLogs(user: $id, orderBy: $orderBy, skip: $skip, take: $take, rangeDate: $rangeDate, filters: $filters) {
      id
      userIP
      useragent
      createdAt
      type
    }
  }
`

export const TOTAL_USER_NOTES = gql`
  query TOTAL_USER_SECURITY_LOGS(
    $userId: ID
    $assignedToId: ID
    $patient: ID
    $doctor: ID
    $appointment: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
  ) {
    totalUserNotes(
      userId: $userId
      assignedToId: $assignedToId
      patient: $patient
      doctor: $doctor
      appointment: $appointment
      rangeDate: $rangeDate
      filters: $filters
    )
  }
`

export const USER_NOTES = gql`
  query USER_SECURITY_LOGS(
    $userId: ID
    $assignedToId: ID
    $patient: ID
    $doctor: ID
    $appointment: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
  ) {
    userNotes(
      userId: $userId
      assignedToId: $assignedToId
      patient: $patient
      doctor: $doctor
      appointment: $appointment
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
    ) {
      id
      child
      tooth
      details
      url
      starred
      seen
      appointment {
        id
        start
        status
      }
      doctor {
        id
        name
      }
      leadStage {
        id
        name
        color
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const USER_SECURITY_LOG_DETAILS = gql`
  query USER_SECURITY_LOG_DETAILS($securityLog: ID!) {
    userSecurityLogDetails(securityLog: $securityLog) {
      id
      userIP
      useragent
      createdAt
      type
    }
  }
`

export const TOTAL_ATTENDANCE_HOURS = gql`
  query TOTAL_ATTENDANCE_HOURS($userId: ID, $id: ID, $rangeDate: [DateTime!]!, $branchId: ID) {
    totalAttendanceHours(userId: $userId, id: $id, rangeDate: $rangeDate, branchId: $branchId)
  }
`

export const PATIENTS_ANALYTICS = gql`
  query PATIENTS_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    patientsAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      patientsInsurance {
        insuranceCompanyId
        _count
      }
      patientsGender {
        gender
        _count
      }
      patientsNationality {
        country
        _count
      }
      patientsAge
      newPatients
      patientsPriceLists {
        priceListId
        _count
      }
      patientsDoctors {
        doctorId
        _count
      }
      insuranceCompanies {
        id
        name
      }
      users {
        id
        name
      }
      priceLists {
        id
        name
      }
      patientsJobs {
        job
        _count
      }
    }
  }
`

export const PATIENTS_LOCATIONS = gql`
  query PATIENTS_LOCATIONS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    patientsLocations(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      longitude
      latitude
    }
  }
`

export const APPOINTMENTS_ANALYTICS = gql`
  query APPOINTMENTS_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    appointmentsAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      appointments {
        status
        _count
      }
      lastAppointments {
        status
        _count
      }
      newAppointments {
        status
        _count
      }
      averageAppointments {
        _avg {
          duration
          waitingDuration
        }
        _max {
          duration
          waitingDuration
        }
        _min {
          duration
          waitingDuration
        }
        _sum {
          duration
          waitingDuration
        }
      }
    }
  }
`

export const APPOINTMENTS_LOCATIONS = gql`
  query APPOINTMENTS_LOCATIONS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    appointmentsLocations(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      patient {
        longitude
        latitude
      }
    }
  }
`

export const INVOICES_ANALYTICS = gql`
  query INVOICES_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    invoicesAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      invoices {
        _sum {
          total
          tax
          discount
          diagnosticFee
          pendingPayment
          paid
          subtotal
        }
      }
      lastInvoices {
        _sum {
          total
          tax
          discount
          diagnosticFee
          pendingPayment
          paid
          subtotal
        }
      }
      newInvoices {
        _sum {
          total
          tax
          discount
          diagnosticFee
          pendingPayment
          paid
          subtotal
        }
      }
      averageInvoices {
        _avg {
          total
          pendingPayment
          paid
        }
        _max {
          total
          pendingPayment
          paid
        }
        _min {
          total
          pendingPayment
          paid
        }
        _sum {
          total
          pendingPayment
          paid
        }
      }
    }
  }
`

export const INVOICES_LOCATIONS = gql`
  query INVOICES_LOCATIONS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    invoicesLocations(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      total
      patient {
        longitude
        latitude
      }
    }
  }
`

export const PAYMENTS_ANALYTICS = gql`
  query PAYMENTS_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    paymentsAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      payments {
        type
        claimed
        _count
        _sum {
          amount
        }
      }
      lastPayments {
        type
        claimed
        _count
        _sum {
          amount
        }
      }
      newPayments {
        type
        claimed
        _count
        _sum {
          amount
        }
      }
      oldPatientPayments {
        _count
        _sum {
          amount
        }
      }
    }
  }
`

export const PAYMENTS_LOCATIONS = gql`
  query PAYMENTS_LOCATIONS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    paymentsLocations(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      amount
      invoice {
        patient {
          longitude
          latitude
        }
      }
    }
  }
`

export const OPERATIONS_ANALYTICS = gql`
  query OPERATIONS_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    operationsAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      operations {
        status
        _count
        _sum {
          total
        }
      }
      lastOperations {
        status
        _count
        _sum {
          total
        }
      }
      newOperations {
        status
        _count
        _sum {
          total
        }
      }
      averageOperations {
        _avg {
          total
        }
        _max {
          total
        }
        _min {
          total
        }
        _sum {
          total
        }
      }
      topProcedures {
        id
        name
        code
        _count {
          operations
        }
      }
    }
  }
`

export const OPERATIONS_LOCATIONS = gql`
  query OPERATIONS_LOCATIONS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    operationsLocations(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      total
      patient {
        longitude
        latitude
      }
    }
  }
`

export const EXPENSES_ANALYTICS = gql`
  query EXPENSES_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    expensesAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      expenses {
        type
        _sum {
          amount
        }
      }
      lastExpenses {
        type
        _sum {
          amount
        }
      }
      newExpenses {
        type
        _sum {
          amount
        }
      }
      averageExpenses {
        _avg {
          amount
        }
        _max {
          amount
        }
        _min {
          amount
        }
        _sum {
          amount
        }
      }
    }
  }
`

export const INCOMES_ANALYTICS = gql`
  query INCOMES_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID, $filters: Filter) {
    incomesAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId, filters: $filters) {
      incomes {
        type
        _sum {
          amount
        }
      }
      lastIncomes {
        type
        _sum {
          amount
        }
      }
      newIncomes {
        type
        _sum {
          amount
        }
      }
      averageIncomes {
        _avg {
          amount
        }
        _max {
          amount
        }
        _min {
          amount
        }
        _sum {
          amount
        }
      }
    }
  }
`

export const TOP_PATIENTS_ANALYTICS = gql`
  query TOP_PATIENTS_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID) {
    topPatientsAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId) {
      operations {
        patientId
        _sum {
          total
        }
      }
      invoiceTotal {
        patientId
        _sum {
          total
        }
      }
      invoicePaid {
        patientId
        _sum {
          paid
        }
      }
      invoicePendingPayment {
        patientId
        _sum {
          pendingPayment
        }
      }
      invoiceDiscount {
        patientId
        _sum {
          discount
        }
      }
      patients {
        id
        firstName
        lastName
      }
    }
  }
`

export const BALANCE_SHEET_ANALYTICS = gql`
  query BALANCE_SHEET_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!, $doctor: ID, $userId: ID) {
    balanceSheetAnalytics(branchId: $branchId, rangeDate: $rangeDate, doctor: $doctor, userId: $userId) {
      patients
      appointments
      appointmentData {
        duration
        feedbackRating
      }
      operations
      operationsCost
      invoices {
        balanceInvoice
        _sum {
          diagnosticFee
          discount
          paid
          pendingPayment
          tax
          total
          balance
          released
        }
      }
      payments {
        type
        claimed
        refunded
        _sum {
          amount
          balance
        }
      }
      expenses {
        expenses {
          type
          _sum {
            amount
            paid
          }
        }
        payments {
          type
          refunded
          _sum {
            amount
          }
        }
      }
      incomes {
        type
        _sum {
          amount
        }
      }
      attendance
      communications
      bankFees
    }
  }
`

export const DOCTORS_ANALYTICS = gql`
  query DOCTORS_ANALYTICS($branchId: ID, $rangeDate: [DateTime!]!) {
    doctorsAnalytics(branchId: $branchId, rangeDate: $rangeDate) {
      patients {
        doctorId
        _count
      }
      appointments {
        doctorId
        _count
      }
      operations {
        doctorId
        _sum {
          total
        }
      }
      invoices {
        doctorId
        _sum {
          total
        }
      }
      users {
        id
        name
        color
      }
    }
  }
`

export const DOCTORS_PERCENTS = gql`
  query DOCTORS_PERCENTS($branchId: ID, $rangeDate: [DateTime!]!) {
    doctorsPercents(branchId: $branchId, rangeDate: $rangeDate) {
      steps {
        doctorId
        _sum {
          discount
        }
      }
      debts {
        userId
        _sum {
          amount
        }
      }
      inventoryUsages {
        userId
        _sum {
          total
        }
      }
      salaryAdjustments {
        userId
        credit
        insurance
        type
        _sum {
          amount
          deduct
        }
      }
      paymentDiscounts {
        doctorId
        refunded
        _sum {
          discount
          amount
        }
      }
      invoices {
        doctorId
        _sum {
          total
          paid
        }
      }
      users {
        id
        name
        isDoctor
        color
        salary
      }
    }
  }
`

export const SIGN_INVOICE = gql`
  query SIGN_INVOICE($invoice: ID!) {
    signInvoice(invoice: $invoice)
  }
`

export const SIGN_PAYMENT = gql`
  query SIGN_PAYMENT($payment: ID!) {
    signPayment(payment: $payment)
  }
`

export const SIGN_QUOTATION = gql`
  query SIGN_QUOTATION($quotation: ID!) {
    signQuotation(quotation: $quotation)
  }
`

export const SIGN_PRESCRIPTION = gql`
  query SIGN_PRESCRIPTION($prescription: ID!) {
    signPrescription(prescription: $prescription)
  }
`

export const SIGN_EXPENSE = gql`
  query SIGN_EXPENSE($expense: ID!) {
    signExpense(expense: $expense)
  }
`

export const SIGN_LAB_ORDER = gql`
  query SIGN_LAB_ORDER($labOrder: ID!) {
    signLabOrder(labOrder: $labOrder)
  }
`

export const SIGN_FORM_INSTANCE = gql`
  query SIGN_FORM_INSTANCE($formInstance: ID!) {
    signFormInstance(formInstance: $formInstance)
  }
`

export const GET_COMPANY_DEFAULT_LANGUAGE = gql`
  query GET_COMPANY_DEFAULT_LANGUAGE($patient: ID!) {
    getCompanyDefaultLanguage(patient: $patient) {
      id
      defaultLanguage
      companyName
      companyLogo
    }
  }
`

export const GET_GOOGLE_CALENDAR_URL = gql`
  query GET_GOOGLE_CALENDAR_URL {
    getGoogleCalendarUrl
  }
`
export const TASKS = gql`
  query TASKS(
    $assignedToId: ID
    $branchId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $searchTerm: String
    $filters: Filter
  ) {
    tasks(
      assignedToId: $assignedToId
      branchId: $branchId
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      searchTerm: $searchTerm
      filters: $filters
    ) {
      id
      name
      details
      days
      due
      type
      when
      approvalRequired
      active
      forAll
      createdAt
      updatedAt
      priority
      branch {
        id
        name
      }
      users {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_TASKS = gql`
  query TOTAL_TASKS($assignedToId: ID, $branchId: ID, $rangeDate: [DateTime!]!, $searchTerm: String, $filters: Filter) {
    totalTasks(
      assignedToId: $assignedToId
      branchId: $branchId
      rangeDate: $rangeDate
      searchTerm: $searchTerm
      filters: $filters
    )
  }
`
export const TASK_DETAILS = gql`
  query TASK_DETAILS($task: ID!) {
    taskDetails(task: $task) {
      id
      name
      details
      days
      due
      type
      when
      approvalRequired
      active
      forAll
      createdAt
      updatedAt
      priority
      branch {
        id
        name
      }
      users {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TASK_INSTANCES = gql`
  query TASK_INSTANCES(
    $assignedToId: ID
    $branchId: ID
    $task: ID
    $userId: ID
    $patient: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $searchTerm: String
    $filters: Filter
  ) {
    taskInstances(
      assignedToId: $assignedToId
      branchId: $branchId
      task: $task
      userId: $userId
      patient: $patient
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      searchTerm: $searchTerm
      filters: $filters
    ) {
      id
      name
      details
      due
      approvalRequired
      approved
      completed
      date
      appointmentType
      notes
      completedAt
      other
      createdAt
      updatedAt
      approvedAt
      priority
      patientId
      labOrderId
      invoiceId
      paymentId
      quotationId
      prescriptionId
      appointmentId
      freeFormInstanceId
      patient {
        id
        firstName
        lastName
        insuranceEndDate
        insuranceCompany {
          id
          name
        }
        doctor {
          id
          name
        }
      }
      approvedBy {
        id
        name
      }
      completedBy {
        id
        name
      }
      branch {
        id
        name
      }
      users {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      operationSteps {
        id
      }
    }
  }
`
export const TOTAL_TASK_INSTANCES = gql`
  query TOTAL_TASK_INSTANCES(
    $assignedToId: ID
    $branchId: ID
    $task: ID
    $userId: ID
    $patient: ID
    $rangeDate: [DateTime!]!
    $searchTerm: String
    $filters: Filter
  ) {
    totalTaskInstances(
      assignedToId: $assignedToId
      branchId: $branchId
      task: $task
      userId: $userId
      patient: $patient
      rangeDate: $rangeDate
      searchTerm: $searchTerm
      filters: $filters
    )
  }
`
export const TASK_INSTANCE_DETAILS = gql`
  query TASK_INSTANCE_DETAILS($taskInstance: ID!) {
    taskInstanceDetails(taskInstance: $taskInstance) {
      id
      name
      details
      due
      approvalRequired
      approved
      completed
      date
      appointmentType
      notes
      completedAt
      other
      createdAt
      updatedAt
      approvedAt
      priority
      patientId
      labOrderId
      invoiceId
      quotationId
      paymentId
      prescriptionId
      appointmentId
      freeFormInstanceId
      patient {
        id
        firstName
        lastName
        insuranceEndDate
        insuranceCompany {
          id
          name
        }
        doctor {
          id
          name
        }
      }
      approvedBy {
        id
        name
      }
      completedBy {
        id
        name
      }
      branch {
        id
        name
      }
      users {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TASK_INSTANCE_INFO = gql`
  query TASK_INSTANCE_INFO(
    $assignedToId: ID
    $branchId: ID
    $task: ID
    $userId: ID
    $patient: ID
    $rangeDate: [DateTime!]!
    $searchTerm: String
    $filters: Filter
  ) {
    taskInstanceInfo(
      assignedToId: $assignedToId
      branchId: $branchId
      task: $task
      userId: $userId
      patient: $patient
      rangeDate: $rangeDate
      searchTerm: $searchTerm
      filters: $filters
    ) {
      approved
      completed
      _count
    }
  }
`

export const SUMMARY_DASHBOARD_STATS = gql`
  query SUMMARY_DASHBOARD_STATS($branchId: ID, $date: DateTime!, $endDate: DateTime, $dob: String!, $dobs: [String!]) {
    summaryDashboardStats(branchId: $branchId, date: $date, endDate: $endDate, dob: $dob, dobs: $dobs) {
      patients {
        type
        _count
      }
      dobPatients
      appointments
      feedbacks
      pendingTasks
      completedTasks
      payments
      cashPayments
      package
      expensePayments
      cashExpensePayments
      sentSMS
      failedSMS
      operations
      totalPoints
      usedPoints
    }
  }
`

export const SUMMARY_PATIENT_CHARTS = gql`
  query SUMMARY_PATIENT_CHARTS($branchId: ID, $dates: [DateTime!]!) {
    summaryPatientCharts(branchId: $branchId, dates: $dates) {
      type
      _count
    }
  }
`
export const SUMMARY_APPOINTMENT_CHARTS = gql`
  query SUMMARY_APPOINTMENT_CHARTS($branchId: ID, $dates: [DateTime!]!) {
    summaryAppointmentCharts(branchId: $branchId, dates: $dates)
  }
`
export const SUMMARY_OPERATIONS_CHARTS = gql`
  query SUMMARY_OPERATIONS_CHARTS($branchId: ID, $dates: [DateTime!]!) {
    summaryOperationsCharts(branchId: $branchId, dates: $dates)
  }
`

export const INCOME_STATEMENT = gql`
  query INCOME_STATEMENT($branchId: ID, $rangeDate: [DateTime!]!) {
    incomeStatement(branchId: $branchId, rangeDate: $rangeDate) {
      operationSteps {
        groupId
        _sum {
          amount
        }
      }
      incomes {
        type
        _sum {
          amount
        }
      }
      expensePayments {
        mainType
        expenseType
        _sum {
          amount
        }
      }
      lastOperationSteps {
        groupId
        _sum {
          amount
        }
      }
      lastIncomes {
        type
        _sum {
          amount
        }
      }
      lastExpensePayments {
        mainType
        expenseType
        _sum {
          amount
        }
      }
      procedureGroups {
        id
        name
      }
      bankFees {
        _sum {
          deducted
        }
      }
      lastBankFees {
        _sum {
          deducted
        }
      }
    }
  }
`
